module.exports = __webpack_public_path__ + "static/img/13.952db9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/13.png
// module id = 3prq
// module chunks = 0